import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { Lock, LockOpen } from "@mui/icons-material";

export const createTogglePinHandler = (setColumnPinning) => (columnId) => (e) => {
  e.stopPropagation()
  setColumnPinning((prev) => {
    const left = [...(prev?.left || [])]
    const idx = left.indexOf(columnId)
    if (idx >= 0) {
      left.splice(idx, 1)
    } else {
      left.push(columnId)
    }
    return { left }
  })
}

export const addPinControlsToColumns = (columns, columnPinning, getToggleHandler) => {
  return columns.map((col) => {
    const colId = col.id || col.accessorKey
    // `material-react-table` uses `columnDef.header` (lowercase) as a string label
    // for sort tooltips/menu items. Keep this as a string.
    const title =
      typeof col.header === 'string'
        ? col.header
        : typeof col?.header?.label === 'string'
          ? col.header.label
          : typeof col?.header?.title === 'string'
            ? col.header.title
            : ''
    const filterVariant = col.filterVariant
    const isRangeFilterVariant = typeof filterVariant === 'string' && filterVariant.includes('range')
    const hasFilter = col.enableColumnFilter !== false
    return {
      ...col,
      // MRT's range inputs (including `date-range`) set their own placeholders (`Min`/`Max`).
      // Don't override them with `Filter by <column>`.
      muiFilterTextFieldProps: hasFilter && title && !isRangeFilterVariant
        ? { placeholder: `Filter by ${title}` }
        : undefined,
      header: title,
      // Render the pin icon without breaking the sort label (which uses `header`).
      Header: (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {title ? <span>{title}</span> : null}
          {colId && (
            <Tooltip
              title={
                (columnPinning?.left || []).includes(colId)
                  ? 'Unlock column'
                  : 'Lock column (pin left)'
              }
            >
              <IconButton size="small" onClick={getToggleHandler(colId)}>
                {(columnPinning?.left || []).includes(colId) ? (
                  <Lock fontSize="inherit" />
                ) : (
                  <LockOpen fontSize="inherit" />
                )}
              </IconButton>
            </Tooltip>
          )}
        </Box>
      ),
    }
  })
}


